import { render, staticRenderFns } from "./btn-button-type.vue?vue&type=template&id=4e4978e0&scoped=true"
import script from "./btn-button-type.vue?vue&type=script&lang=js"
export * from "./btn-button-type.vue?vue&type=script&lang=js"
import style0 from "./btn-button-type.vue?vue&type=style&index=0&id=4e4978e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4978e0",
  null
  
)

export default component.exports